import { CIcon } from '~/icons/types'
export const ciMotor: CIcon = {
  width: 512,
  height: 386,
  paths: [
    {
      d:
        'M473.6 78.4h-49.2v48.1h-18.2l-49.4-63.1c-6.5-6.1-15-9.5-24-9.5H224V21h79.9c5.8 0 10.5-4.7 10.5-10.5S309.7 0 303.8 0H125.9c-5.8 0-10.5 4.7-10.5 10.5S120.1 21 125.9 21h81v32.9h-79.2c-16.1 0-29.1 13-29.1 29.1v24.3H70.1c-16.1 0-29.1 13-29.1 29.1v58.3H21v-66.2c0-5.8-4.7-10.5-10.5-10.5S0 122.6 0 128.4v155.8c0 5.8 4.7 10.5 10.5 10.5S21 290 21 284.2v-68.6h20V280c0 16.1 13 29.1 29.1 29.1h38.2l76.6 68.1c6.4 5.7 14.6 8.8 23.2 8.8h169.1c16.1 0 29.1-13 29.1-29.1v-57.4h18.2v45.9h49.2c21.2 0 38.4-17.2 38.4-38.4V116.8c-.1-21.2-17.3-38.4-38.5-38.4zM491 307c0 9.6-7.8 17.4-17.4 17.4h-28.2v-45.9h-60.2v78.4c0 4.4-3.6 8.1-8.1 8.1h-169c-3.4 0-6.7-1.2-9.2-3.5l-76.6-68.1-6-5.3H70.1c-4.4 0-8.1-3.6-8.1-8.1v-72.7c.2-.7.2-1.5.2-2.2s-.1-1.5-.2-2.2v-66.5c0-4.4 3.6-8.1 8.1-8.1h49.6V83c0-4.4 3.6-8.1 8.1-8.1H213c.8.2 1.6.3 2.5.3s1.7-.1 2.5-.3h115c3.1 0 6.2 1.1 8.6 3l48.2 61.6 6.3 8.1h49.4v-48h28.2c9.6 0 17.4 7.8 17.4 17.4v190h-.1z'
    }
  ],
  name: 'motor',
  type: 'regular'
}
